export const uk = {
    horizontal: 'Горизонтальный',
    square: 'Квадратный',
    vertical: 'Вертикальный'
};
